import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import * as icon from "@coreui/icons";

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/client-details/AppDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'
import { useResponsive } from 'src/helpers/get-responsive'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ClientDetails = () => {
  const isDesktop = useResponsive()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [clientDetails, setClientDetails] = useState('')

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const handleCardHeaderButton = () => {
    navigate(`/client/edit/${id}`)
  }

  useEffect(() => {
    fetchClientDetails()
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [id]);

  const fetchClientDetails = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/client/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let clientValue = data?.value
          let othersPICValue = clientValue?.others_pic

          if (othersPICValue?.length > 0) {
            othersPICValue = othersPICValue?.map((e) => {
              return {
                ...e,
                phone_number: e?.contact_number,
                country_value: JSON.stringify({
                  id: e?.country_value?.id,
                  name: e?.country_value?.name,
                  icon: icon[`cif${e?.country_value?.country_code}`],
                  phone_code: e?.country_value?.phone_code
                })
              }
            })
          }
          clientValue.others_pic = othersPICValue
          setClientDetails(clientValue)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <div className='d-grid gap-2 d-flex justify-content-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/client/list')} size={isDesktop ? 'md' : 'sm'}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<span className='fs-5 fs-md-4'>Client Details</span>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            clientDetails={clientDetails}
            handleViewFile={setOpenFilePreview}
          />
        }
        lowerBodyContent={
          <AppCard 
            className='mb-4'
            headerTitle={<span className='fs-6 fs-md-4'>Attachments</span>}
            bodyContent={
              <>
                {
                  clientDetails?.attachments?.length > 0 ? (
                    <FormFileThumbnail 
                      name='employee_attachments'
                      colSize='4'
                      files={clientDetails?.attachments}
                      className='justify-content-start align-items-center'
                      isDetailPage={true}
                      handleViewFile={setOpenFilePreview}
                    />
                  )
                  : (
                    <>Not Found</>
                  )
                }
              </>
            }
          />
        }
      />
    </>
  )
}

export default ClientDetails
